import {
  Button,
  Card,
  Table,
  Tooltip,
  Input,
  Row,
  Col,
  DatePicker,
} from "antd";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import DeleteModal from "../../components/DeleteModal";
import apiPath from "../../constants/apiPath";
import { AppStateContext } from "../../context/AppContext";
import lang from "../../helper/langHelper";
import { Severty, ShowToast } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import useRequest from "../../hooks/useRequest";
import { APIServices } from "../../services/AuthAPIs";

const { RangePicker } = DatePicker;
const Search = Input.Search;
const api = {
  status: apiPath.statusCustomer,
  addEdit: apiPath.addEditCustomer,
  list: apiPath.listCustomer,
  delete: apiPath.listCustomer,
  addMoney: apiPath.addMoney,
};

function Index() {
  const heading = "Leaderboard Manager";
  const { setPageHeading } = useContext(AppStateContext);
  const { getData, deleteData } = APIServices();

  const { request } = useRequest();
  const [searchText, setSearchText] = useState("");
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [selected, setSelected] = useState();
  const [showDelete, setShowDelete] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const debouncedSearchText = useDebounce(searchText, 300);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const columns = [
    {
      title: "Rank",
      dataIndex: "rank",
      key: "rank",
      render: (_, { rank }) => {
        return rank ? rank : ("-");
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
      render: (_, { user_id }) => {
        return user_id ? user_id?.name : "-";
      },
    },
    {
      title: "Level",
      dataIndex: "current_level",
      key: "current_level",
      width: 200,
      render: (_, { current_level }) => {
        return current_level ? current_level : 0;
      },
    },
    {
      title: "Total Challenges",
      dataIndex: "total_challenges",
      key: "total_challenges",
      width: 200,
      render: (_, { total_challenges }) => {
        return total_challenges ? total_challenges : 0;
      },
    },
    {
      title: "Completed Challenges",
      dataIndex: "completed_challenges",
      key: "completed_challenges",
      width: 200,
      render: (_, { completed_challenges }) => {
        return completed_challenges ? completed_challenges : 0;
      },
    },

  ];

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ ...pagination, current: 1, });
  };

  const handleChangeDate = (e) => {
    if (e != null) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    } else {
      setStartDate();
      setEndDate();
    }
  };

  const handleChange = (pagination, filters) => {
    const payload = {
      page: pagination.current || 1,
      pageSize: pagination.pageSize || 10,
      search: debouncedSearchText,
      status: "",
      startDate: "",
      endDate: "",
    };
    getData(
      apiPath.getLeaderboard,
      payload,
      setList,
      setLoading,
      setPagination,
      pagination
    );
  };

  useEffect(() => {
    const payload = {
      page: pagination.current || 1,
      pageSize: pagination.pageSize || 10,
      search: debouncedSearchText,
      status: "",
      startDate: "",
      endDate: "",
    };
    getData(
      apiPath.getLeaderboard,
      payload,
      setList,
      setLoading,
      setPagination,
      pagination
    );
  }, [refresh, debouncedSearchText, startDate, endDate]);

  useEffect(() => {
    setPageHeading(heading);
  }, [setPageHeading]);

  return (
    <>
      <div className="tabled productCaralogue">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={"User Leaderboard"}
              extra={
                <>
                  <div className="button_group justify-content-end w-100">
                    <Search
                      allowClear
                      className="search-input"
                      size="large"
                      onChange={onSearch}
                      value={searchText}
                      onPressEnter={onSearch}
                      placeholder="Search By Name"
                      title="Search By Name"
                    />
                    {/* <RangePicker
                      disabledDate={(current) => current.isAfter(Date.now())}
                      onChange={handleChangeDate}
                    /> */}
                  </div>
                </>
              }
            >
              <div className="table-responsive customPagination checkBoxSrNo">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list?.data}
                  pagination={{
                    current: pagination?.current,
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: false,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      {showDelete && (
        <DeleteModal
          title={lang("Delete User")}
          subtitle={lang(`Are you sure you want to delete this user?`)}
          show={showDelete}
          hide={() => {
            setShowDelete(false);
            setSelected();
          }}
          onOk={() =>
            deleteData(
              apiPath.deleteCustomer,
              selected?._id,
              setLoading,
              setRefresh
            )
          }
        />
      )}
    </>
  );
}

export default Index;
